import { cn } from "@/lib/utils";
import { makeBaseComponentId } from "@/util/make-component-id";
import { CSSProperties } from "react";

const MaxWidthWrapper = ({
    className,
    style,
    children,
    disabledPadding,
    sectionWidth = "CONTAINER",
    contentWidth = "CONTAINER",
    noPadding = false,
}: {
    className?: string;
    children: React.ReactNode;
    style?: CSSProperties;
    disabledPadding?: boolean;
    sectionWidth?: "CONTAINER" | "FLUID";
    contentWidth?: "CONTAINER" | "FLUID";
    noPadding?: boolean;
}) => {
    let paddingClass = noPadding ? "w-full px-4 lg:px-0" : "w-full px-4 sm:px-10";
    return (
        <div
            id={makeBaseComponentId("max-width-wrapper-base", `base-${sectionWidth}-${contentWidth}`)}
            className={cn(
                paddingClass,
                sectionWidth === "CONTAINER" ? "mx-auto max-w-screen-2xl" : "",
                className,
                disabledPadding ?? false ? "sm:px-0 px-0" : "",
            )}
            style={style}>
            <div
                id={makeBaseComponentId("max-width-wrapper-content", `content-${sectionWidth}-${contentWidth}`)}
                className={cn(contentWidth === "CONTAINER" ? "mx-auto max-w-screen-2xl" : "")}>
                {children}
            </div>
        </div>
    );
};

export default MaxWidthWrapper;
